import { render } from "./buildingCommunties.vue?vue&type=template&id=84af5f38"
import script from "./buildingCommunties.vue?vue&type=script&lang=js"
export * from "./buildingCommunties.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__